import { Component, OnInit } from '@angular/core';
import {ExcListConfig} from 'exc-controls';
import {ExcRestService} from 'exc-rest';
import {ExcCoreModule, ExcTranslation} from 'exc-core';
import {ExcTab} from 'exc-tab';
import {ProviderConfigComponent} from '../provider-config/provider-config.component';

@Component({
  selector: 'app-provider-client-list',
  templateUrl: './provider-client-list.component.html',
  styles: []
})
export class ProviderClientListComponent extends ExcTranslation implements OnInit {

  clientListConfig: ExcListConfig = new ExcListConfig();
  clientListData: any;
  clientSearchValue = '';

  constructor(private excrest: ExcRestService) {
    super();
   const _self = this;
    _self.clientListConfig.OnSearch = (searchValue) => {
      _self.clientSearchValue = searchValue;
      _self.loadClients();
    };
    _self.clientListConfig.OnRefresh = (event) => {
      _self.loadClients();
    };
    _self.clientListConfig.OnPageChanged = (pageNo, event) => {
      _self.loadClients();
    };
    _self.clientListConfig.selectFirstAfterInit = true;
  }

  ngOnInit() {
    const _self = this;
    _self.loadClients();
  }

  loadClients() {
    const _self = this;
    _self.clientListConfig.isLoading = true;
    _self.excrest.sget(_self.excrest.computeUrl('Provider_ClientR_List',
      {fts: _self.clientSearchValue}), ExcCoreModule.Guid.NewGuid(),
      {})
      .subscribe(response => {
        if (response.response !== null) {
        if (response.response.data !== undefined) {
          _self.clientListData = response.response.data;
          _self.clientListConfig.paging = response.response.paging;
        }

        _self.clientListConfig.isLoading = false;
      }
      });
  }

  openConfigurationTab(data = null) {
    const _self = this;
 /*   new ExcTab(data.Mdt_Kbz, ProviderConfigComponent, {
      data: data
    }, data.Mdt_Id, {Unique: true}, true, 'far fa-cog').Open();*/
    new ExcTab('Demo Client', ProviderConfigComponent, {
      data: data
    }, '3', {Unique: true}, true, 'far fa-cog').Open();
  }

}
